import { getOrigin } from 'owa-url';
import { Version, ObjectType } from './restAPIConstants';
import GroupFolderAction from './GroupFolderAction';

export const getEndpointUrl = (
    action: GroupFolderAction,
    groupId: string,
    folderId: string
): string => {
    const originUrl = getOrigin();
    let endpointUrl = `${originUrl}${Version.Beta}${ObjectType.Groups}${groupId}/${ObjectType.MailFolders}`;

    switch (action) {
        case GroupFolderAction.CreateFolder:
            endpointUrl = `${endpointUrl}/${folderId}/${ObjectType.ChildFolders}`;
            break;
        case GroupFolderAction.RenameFolder:
            endpointUrl = `${endpointUrl}/${folderId}`;
            break;
        case GroupFolderAction.CopyFolder:
            endpointUrl = `${endpointUrl}/${folderId}/${ObjectType.CopyFolder}`;
            break;
        case GroupFolderAction.MoveFolder:
            endpointUrl = `${endpointUrl}/${folderId}/${ObjectType.MoveFolder}`;
            break;
        default:
            throw new Error('This GroupFolderAction is not supported');
    }

    return endpointUrl;
};
